module.exports = __webpack_public_path__ + "static/img/guide-22.9605ccaf.png";